import { defineMessages } from 'react-intl-next';

export const messages: {
	cancelButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confirmButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	cancelButtonLabel: {
		id: 'company-hub.links-menu-extension.config-panel.property-config.cancel-button-label',
		defaultMessage: 'Cancel',
		description:
			'Text for the cancel button shown on the footer of the add menu form when the user selects the "Menu" option in the "New Item" popup in the links menu configuation panel.',
	},
	confirmButtonLabel: {
		id: 'company-hub.links-menu-extension.config-panel.property-config.confirm-button-label',
		defaultMessage: 'Confirm',
		description:
			'Text for the confirm button shown on the footer of the add menu form when the user selects the "Menu" option in the "New Item" popup in the links menu configuation panel.',
	},
});
